module.exports = __webpack_public_path__ + "static/03-704daacb07357bbbaceb66327723f4d5.jpg";